var _rect, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserShield(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 27,
    viewBox: "0 0 26 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 26,
    height: 26,
    rx: 13,
    fill: "#009DE2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.9817 17.3923C10.419 17.3923 9.57985 18.5085 9.30484 19.2488C9.26975 19.3433 9.30353 19.4482 9.38288 19.5103C11.0598 20.8238 12.8451 21.3893 12.8784 21.3998C12.9184 21.4115 12.9592 21.4173 12.9992 21.4173C13.0401 21.4173 13.0809 21.4115 13.1209 21.3998C13.1542 21.3893 14.9258 20.8278 16.5965 19.5256C16.6758 19.4638 16.7099 19.3593 16.6753 19.2648C16.4016 18.5162 15.5622 17.3923 12.9817 17.3923Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.9855 10.5002C12.0214 10.5002 11.2363 11.2852 11.2363 12.2511C11.2363 13.2161 12.0214 14.0003 12.9855 14.0003C13.9497 14.0003 14.7347 13.2161 14.7347 12.2511C14.7347 11.2852 13.9497 10.5002 12.9855 10.5002Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.9857 15.2499C11.3324 15.2499 9.98654 13.9041 9.98654 12.2499C9.98654 10.5958 11.3324 9.24992 12.9857 9.24992C14.639 9.24992 15.9848 10.5958 15.9848 12.2499C15.9848 13.9041 14.639 15.2499 12.9857 15.2499ZM19.1298 7.77992C18.5423 7.19242 13.854 5.58325 12.9998 5.58325C12.1457 5.58325 7.45737 7.19242 6.86987 7.78075C6.4032 8.24992 6.40903 8.61075 6.4457 10.6124C6.4607 11.4233 6.4807 12.5283 6.4807 14.0583C6.4807 15.7786 7.14258 17.1437 8.03662 18.2123C8.14988 18.3478 8.36339 18.317 8.4563 18.1669C9.15003 17.0463 10.5637 16.1416 12.9823 16.1416C15.4177 16.1416 16.8371 17.0531 17.5295 18.1828C17.6219 18.3336 17.8357 18.3652 17.9494 18.2298C18.8507 17.1584 19.5198 15.7881 19.5198 14.0583C19.5198 12.5324 19.5398 11.4291 19.5548 10.6174C19.5907 8.61159 19.5973 8.25075 19.1298 7.77992Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserShield);
export default __webpack_public_path__ + "static/media/UserShield.9221812d3e59138967014a0d644f46dc.svg";
export { ForwardRef as ReactComponent };